import type { Scene } from '../types';

export interface PlaceholderConfig {
  chapter: string;
  color: string;
  description: string;
}

export class ScenePlaceholder implements Scene {
  readonly panel: HTMLElement;

  constructor(root: HTMLElement, config: PlaceholderConfig) {
    this.panel = document.createElement('div');
    this.panel.className = 'sm-panel sm-panel-placeholder';
    this.panel.dataset['scene'] = 'placeholder';
    this.panel.innerHTML = `
      <div class="sm-ph-body">
        <div class="sm-ph-icon" style="color:${config.color};">◈</div>
        <div class="sm-ph-chapter" style="color:${config.color};">${config.chapter}</div>
        <div class="sm-ph-badge">Coming Soon</div>
        <div class="sm-ph-description">${config.description}</div>
        <div class="sm-ph-note">
          This chapter will be built as field data, remote sensing products, and
          intervention records become available. The foundation model baseline
          established in the Habitat &amp; Biodiversity chapter provides the
          reference state against which all future changes will be measured.
        </div>
      </div>
    `;
    root.appendChild(this.panel);
  }

  onEnter(): void { /* no map layers */ }
  onLeave(): void { /* nothing to clean up */ }
}
